import { render, staticRenderFns } from "./CardSectionPages.vue?vue&type=template&id=4586e070&"
import script from "./CardSectionPages.vue?vue&type=script&lang=js&"
export * from "./CardSectionPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports